import { campaignCache } from '../utils/campaign.util';
import { AACampaign } from "@akross/artemis-ads-sdk";
import { logger } from '../utils/logger.util';

export class CampaignDetailService {
  /**
   * Busca detalhes de uma campanha específica
   * Usa apenas o cache (dados já carregados na home)
   */
  async getCampaignDetail(campaignId: string): Promise<AACampaign | null> {
    try {
      logger.debug('[CampaignDetailService] Buscando campanha do cache, campaignId:', campaignId);

      // Buscar do cache
      const campaign = campaignCache.getCampaign(campaignId);

      if (campaign) {
        logger.debug('[CampaignDetailService] Campanha encontrada no cache');
        // Retornar como AACampaign (EnrichedAACampaign é compatível)
        return campaign as AACampaign;
      }

      logger.warnWithContext('CampaignDetailService', 'Campanha não encontrada no cache, campaignId:', campaignId);
      return null;
    } catch (error: unknown) {
      logger.error('[CampaignDetailService] Erro ao buscar detalhes da campanha:', error);
      return null;
    }
  }
}

export const campaignDetailService = new CampaignDetailService();

